import { render, staticRenderFns } from "./PuzzleResponseItem.vue?vue&type=template&id=70afeef7"
import script from "./PuzzleResponseItem.vue?vue&type=script&lang=ts"
export * from "./PuzzleResponseItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports